import { Component, h } from 'preact';
import CSSModules from 'react-css-modules';
import ClassNames from 'classnames';
import styles from '../../css/app.css';
import { Link } from 'preact-router/match';
import { route } from 'preact-router';
import TweenLite from 'gsap/TweenLite';
import TimelineLite from 'gsap/TimelineLite';

// IMPORT Settings + Data
import events from '../../utils-and-data/events.js';
import { LS, SendGAPageView } from '../../utils-and-data/utils.js';

class WelcomePages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'title',
      readyForBook: false,
    };

    // To ensure content is properly re-loaded, reset the book pages
    props.pages && props.pages[0].paragraphs && events.emit('clearPageOne');
  }

  componentDidMount() {
    let currentRoute = '/';
    if (this.props.returning) {

      // Alert GoogleAnalytics of the route change...
      currentRoute += '?returning=true';

      // Clear out the state:
      history.replaceState({}, `Welcome Pages`, '/');
      
      // Just go straight to loading:
      this.incrementMode();
    }

    SendGAPageView({
      title: 'Welcome pages',
      path: currentRoute
    });
  }

  componentWillUnmount() {

    // Reset all animation and styles:
    this.tl && this.tl.kill();
    TweenLite.set([
      this.containerRef, this.hgroupRef, this.h1Ref,
      this.blurbRef, this.ctaRef, 
    ], { clearProps: "all" });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.pages
      && this.props.pages[0].paragraphs
      && !this.state.readyForBook) {

      // Enough book pages have come down! 
      // Trigger final "ready" mode
      this.setState({ readyForBook: true });
      this.incrementMode();
    }
  }

  incrementMode = (ev) => {
    if (ev) ev.preventDefault();

    switch (this.state.mode) {
      case 'title':
        let newMode = LS.get('permissions-asked')
          ? 'loading'
          : 'permissions';
        this.setState({ mode: newMode }); 
        this.uiReact2State(newMode);
        break;

      case 'permissions':
        LS.set('permissions-asked', true);
        this.setState({ mode: 'loading' });
        this.uiReact2State('loading');
        break;

      case 'loading':
        this.setState({ mode: 'ready' });
        this.uiReact2State('ready');
        break;

      // Finally ready. So change route, to /book
      case 'ready':
        TweenLite.to(this.containerRef, 0.6, {
          backgroundColor: 'white',
          onComplete: () => route('/book'),
        });
        TweenLite.to([this.h1Ref, this.hgroupRef, this.ctaRef], 0.5, {
          opacity: 0,
        });
        break;
    }
  }

  uiReact2State = newMode => {
    this.tl = new TimelineLite({
      paused: true
    });

    switch (newMode) {
      case 'loading':
        this.props.beginLoaders();
        this.tl.to(this.ctaRef, 0.3, {
          opacity: 0,
          ease: Quart.easeInOut }, 0)
          .to(this.hgroupRef, 1, {
            top: 'auto',
            bottom: '7vh',
            color: 'rgba(255,255,255,1)',
            ease: Quart.easeInOut }, 1)
          .to(this.containerRef, 1, {
            backgroundColor: 'rgba(255,255,255,0)' }, 1.7)
          .to(this.h1Ref, 1.2, {
            top: '25vh',
            color: 'rgba(255,255,255,1)',
            ease: Quart.easeInOut }, 1.7);
        break;

      case 'ready':
        this.tl.to(this.h1Ref, 1.2, {
          top: '25vh',
          color: 'rgba(255,255,255,1)',
          ease: Quart.easeInOut }, 0)
          .to(this.hgroupRef, 1, {
            opacity: 0,
            ease: Quart.easeInOut }, 0)
          .to(this.blurbRef, 1, {
            opacity: 1,
            ease: Quart.easeInOut }, 0)
          .to(this.ctaRef, 1, {
            opacity: 1,
            color: 'rgba(255,255,255,1)',
            ease: Quart.easeInOut }, 0);
        break;

      case 'permissions':
        this.tl.to(this.h1Ref, 1.2, {
          top: '18vh',
          ease: Quart.easeInOut })
          .to(this.hgroupRef, 1, {
            top: '32vh',
            bottom: 'auto',
            ease: Quart.easeInOut }, 0);
        break;
    }

    this.tl.play();
  }

  render() {
    return (
      <div styleName='welcome-pages'
        className={ClassNames(this.state.mode)}
        ref={w => this.storeRef('containerRef', w)}>

        <h1 ref={h => this.storeRef('h1Ref', h)}>{this.props.bookTitle}</h1>

        <hgroup ref={h => this.storeRef('hgroupRef', h)}>
          <h3>A Ghost Story</h3>
          <h2>By Kate Pullinger</h2>
        </hgroup>

        <div ref={h => this.storeRef('blurbRef', h)}
          className='blurb'>

          Welcome to the world of Flo.<br />
          She can talk to ghosts.<br />
          And she knows where you are.
        </div>

        <div className='cta-area'
          ref={c => this.storeRef('ctaRef', c)}>
          
          <span>
            {this.state.mode === 'ready' 
              ? 'Is your phone in your hand?' 
              : 'Pick up your phone'}
          </span>
          <button onClick={this.incrementMode}>
            {this.state.mode === 'ready' 
              ? "Yes. I'm ready." 
              : "I'm ready"}
          </button>
        </div>

        <div className='permissions'>
          <p>This book is sensitive to the world around you. For the best 
            experience, we'd like to access your camera &amp; location. None of 
            this data is stored online, but it may be stored locally, on your 
            device, to enhance the reading experience.</p>
          <button onClick={this.incrementMode}>I understand</button>
        </div>

      </div>
    )
  }

  storeRef(name, el) {
    // console.log('store a ref:', el);
    if (el !== null) this[name] = el;
  }
}


// Apply 'react-css-modules' to this react component:
export default CSSModules(WelcomePages, styles);





// WEBPACK FOOTER //
// ./app/frontend/components/routes/welcome-pages.jsx